export type EnemyCategory = "machine" | "produce";

export type EnemySpriteId =
  | "machine-harvest-drone"
  | "machine-silo"
  | "machine-tractor"
  | "machine-truck"
  | "machine-warehouse-tug"
  | "produce-apple"
  | "produce-broccoli"
  | "produce-corn"
  | "produce-pepper"
  | "produce-watermelon";

export interface EnemySpec {
  category: EnemyCategory;
  renderWidth: number;
  renderHeight: number;
  collisionWidth: number;
  collisionHeight: number;
}

export const ENEMY_SPECS: Readonly<Record<EnemySpriteId, EnemySpec>> = {
  "machine-harvest-drone": { category: "machine", renderWidth: 78, renderHeight: 43, collisionWidth: 68, collisionHeight: 34 },
  "machine-silo": { category: "machine", renderWidth: 62, renderHeight: 47, collisionWidth: 52, collisionHeight: 40 },
  "machine-tractor": { category: "machine", renderWidth: 72, renderHeight: 48, collisionWidth: 64, collisionHeight: 40 },
  "machine-truck": { category: "machine", renderWidth: 80, renderHeight: 41, collisionWidth: 72, collisionHeight: 34 },
  "machine-warehouse-tug": { category: "machine", renderWidth: 78, renderHeight: 41, collisionWidth: 70, collisionHeight: 34 },
  "produce-apple": { category: "produce", renderWidth: 52, renderHeight: 56, collisionWidth: 44, collisionHeight: 48 },
  "produce-broccoli": { category: "produce", renderWidth: 64, renderHeight: 48, collisionWidth: 56, collisionHeight: 40 },
  "produce-corn": { category: "produce", renderWidth: 34, renderHeight: 60, collisionWidth: 28, collisionHeight: 52 },
  "produce-pepper": { category: "produce", renderWidth: 25, renderHeight: 64, collisionWidth: 18, collisionHeight: 54 },
  "produce-watermelon": { category: "produce", renderWidth: 54, renderHeight: 51, collisionWidth: 46, collisionHeight: 44 },
};

export const MACHINE_ENEMY_IDS = [
  "machine-harvest-drone",
  "machine-silo",
  "machine-tractor",
  "machine-truck",
  "machine-warehouse-tug",
] as const satisfies readonly EnemySpriteId[];

export const PRODUCE_ENEMY_IDS = [
  "produce-apple",
  "produce-broccoli",
  "produce-corn",
  "produce-pepper",
  "produce-watermelon",
] as const satisfies readonly EnemySpriteId[];

export function enemyIdsForWeakness(weakness: "core" | "pulp"): readonly EnemySpriteId[] {
  return weakness === "pulp" ? MACHINE_ENEMY_IDS : PRODUCE_ENEMY_IDS;
}
